import React, { FC, useEffect, useMemo } from 'react';
import { RouteConfig } from './route-config';
import { usePatientProfilePage } from '../hooks';

export const PatientProfilePageRouter: FC = () => {
  const { route } = usePatientProfilePage();
  const component = useMemo(() => RouteConfig.find(x => x.path == route)?.component, [route]);

  return <>{component && React.createElement(component)}</>
}